import { Center, Loader } from "../../elements";

export function Loading() {
  return (
    <Center my="auto">
      <Loader />
    </Center>
  );
}
